<template>
  <div class="w-full h-full bg-black px-6 custom-bottom-padding">
    <p class="text-grey uppercase font-medium text-xl px-4 pt-8">Vault Settings</p>
    <ul class="w-full">
      <div v-if="$route.params.vault_id != undefined">
        <li
          class="font-medium text-brand uppercase py-2 mx-4 mt-6"
          v-is-authorized="{ roles: [role], permissions: ['can_manage_roles_restrictions', 'can_view_members', 'can_add_members'] }"
        >Manage Users/Permissions</li>
        <li v-is-authorized="{ roles: [role], permissions: ['can_add_members'] }">
          <router-link
            :to="{name:'invite-members', params: {vault_id: $route.params.vault_id}}"
            @click.native="closeSettings()"
            class="font-medium text-white no-underline py-2 ml-4 block border-b border-grey-dark"
            active-class=" border-l-4 border-brand pl-2"
          >Invite New Members</router-link>
        </li>
        <li v-is-authorized="{ roles: [role], permissions: ['can_add_members'] }">
          <router-link
            :to="{name: 'add-delete-members', params: {vault_id: $route.params.vault_id}}"
            class="font-medium text-white no-underline py-2 ml-4 block border-b border-grey-dark"
            active-class=" border-l-4 border-brand pl-2"
            @click.native="closeSettings()"
          >Edit/delete members</router-link>
        </li>
        <li v-is-authorized="{ roles: [role], permissions: ['can_add_members'] }">
          <router-link
            :to="{name: 'role-restrictions-tag', params: {vault_id: $route.params.vault_id}}"
            class="font-medium text-white no-underline py-2 ml-4 block border-b border-grey-dark"
            active-class=" border-l-4 border-brand pl-2"
            @click.native="closeSettings()"
          >Role Restrictions per Tag</router-link>
        </li>
      </div>

      <div v-is-authorized="{ roles: [role], permissions: ['can_access_billing_invoicing'] }">
        <li class="font-medium text-brand uppercase py-2 mx-4 mt-6">Billing &amp; Account</li>
        <li>
          <router-link
            :to="{name: 'subscription', params: {vault_id: $route.params.vault_id}}"
            class="font-medium text-white no-underline py-2 ml-4 block border-b border-grey-dark"
            active-class=" border-l-4 border-brand pl-2"
            @click.native="closeSettings()"
          >Subscription and Invoices</router-link>
        </li>
        <li>
          <router-link
            :to="{name: 'change-plan', params: {vault_id: $route.params.vault_id}}"
            class="font-medium text-white no-underline py-2 ml-4 block border-b border-grey-dark"
            active-class=" border-l-4 border-brand pl-2"
            @click.native="closeSettings()"
          >Change Plan</router-link>
        </li>
        <li>
          <router-link
            :to="{name: 'update-billing-details', params: {vault_id: $route.params.vault_id}}"
            class="font-medium text-white no-underline py-2 ml-4 block border-b border-grey-dark"
            active-class=" border-l-4 border-brand pl-2"
            @click.native="closeSettings()"
          >Update billing details</router-link>
        </li>
      </div>
      <!-- <li>
                <a href="#" class="font-medium text-white no-underline py-2 ml-4 block border-b border-grey-dark" @click.prevent="$refs.not_available.open()">
                    Transfer ownership
                </a>
      </li>-->
      <div v-if="$route.params.vault_id != undefined">
        <li class="font-medium text-brand uppercase py-2 mx-4 mt-6">Vault Details</li>
        <li>
          <router-link
            :to="{name: 'vault-details', params: {vault_id: $route.params.vault_id}}"
            class="font-medium text-white no-underline py-2 ml-4 block border-b border-grey-dark"
            active-class=" border-l-4 border-brand pl-2"
            @click.native="closeSettings()"
          >View Vault Details</router-link>
        </li>
        <li v-is-authorized="{ roles: [role], permissions: ['can_transfer_ownership'] }">
          <router-link
            :to="{name: 'transfer-ownership', params: {vault_id: $route.params.vault_id}}"
            class="font-medium text-white no-underline py-2 ml-4 block border-b border-grey-dark"
            active-class=" border-l-4 border-brand pl-2"
            @click.native="closeSettings()"
          >Transfer Ownership</router-link>
        </li>
        <li v-is-authorized="{ roles: [role], permissions: ['can_manage_tags'] }" v-if="is_enabled">
          <router-link
            :to="{name: 'manage-tags', params: {vault_id: $route.params.vault_id}}"
            class="font-medium text-white no-underline py-2 ml-4 block border-b border-grey-dark"
            active-class=" border-l-4 border-brand pl-2"
            @click.native="closeSettings()"
          >Manage Tags</router-link>
        </li>
      </div>
    </ul>
    <sweet-modal
      icon="warning"
      ref="not_available"
      overlay-theme="dark"
    >This feature is not yet available</sweet-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  methods: {
    closeSettings() {
      this.$emit("close-settings");
    }
  },

  computed: {
    ...mapGetters({
      role: "getUserRole"
    }),

    is_enabled() {
      return window.enable_tag_editing;
    }
  }
};
</script>

<style>
.custom-bottom-padding {
  padding-bottom: 100px;
}
</style>
